import {
    GET_SERVICE_TYPE_LISTING,
    GET_SERVICE_TYPE_LISTING_SUCCESS,
    GET_SERVICE_TYPE_LISTING_FAIL,
    GET_SERVICE_TYPE_DETAILS,
    GET_SERVICE_TYPE_DETAILS_SUCCESS,
    GET_SERVICE_TYPE_DETAILS_FAIL,
    ADD_SERVICE_TYPE,
    ADD_SERVICE_TYPE_SUCCESS,
    ADD_SERVICE_TYPE_FAIL,
    UPDATE_SERVICE_TYPE,
    UPDATE_SERVICE_TYPE_SUCCESS,
    UPDATE_SERVICE_TYPE_FAIL,
    DELETE_SERVICE_TYPE,
    DELETE_SERVICE_TYPE_SUCCESS,
    DELETE_SERVICE_TYPE_FAIL,
    BULK_DELETE_SERVICE_TYPE,
    BULK_DELETE_SERVICE_TYPE_SUCCESS,
    BULK_DELETE_SERVICE_TYPE_FAIL,
    EXPORT_SERVICE_TYPE,
    EXPORT_SERVICE_TYPE_SUCCESS,
    EXPORT_SERVICE_TYPE_FAIL,
    RESET_SERVICE_TYPE_STATE,
    RESET_SERVICE_TYPE_ATTACHMENT_STATE,
} from "./actionTypes";

export const getServiceTypeListing = (serviceType) => ({
    type: GET_SERVICE_TYPE_LISTING,
    payload: serviceType,
});

export const getServiceTypeListingSuccess = serviceType => ({
    type: GET_SERVICE_TYPE_LISTING_SUCCESS,
    payload: serviceType,
});

export const getServiceTypeListingFail = error => ({
    type: GET_SERVICE_TYPE_LISTING_FAIL,
    payload: error,
});

export const getServiceTypeDetails = serviceTypeId => ({
    type: GET_SERVICE_TYPE_DETAILS,
    payload: serviceTypeId,
});

export const getServiceTypeDetailsSuccess = serviceType => ({
    type: GET_SERVICE_TYPE_DETAILS_SUCCESS,
    payload: serviceType,
});

export const getServiceTypeDetailsFail = error => ({
    type: GET_SERVICE_TYPE_DETAILS_FAIL,
    payload: error,
});

export const createServiceType = serviceType => ({
    type: ADD_SERVICE_TYPE,
    payload: serviceType,
});

export const createServiceTypeSuccess = serviceType => ({
    type: ADD_SERVICE_TYPE_SUCCESS,
    payload: serviceType,
});

export const createServiceTypeFail = error => ({
    type: ADD_SERVICE_TYPE_FAIL,
    payload: error,
});

export const updateServiceType = serviceType => ({
    type: UPDATE_SERVICE_TYPE,
    payload: serviceType,
});

export const updateServiceTypeSuccess = serviceType => ({
    type: UPDATE_SERVICE_TYPE_SUCCESS,
    payload: serviceType,
});

export const updateServiceTypeFail = error => ({
    type: UPDATE_SERVICE_TYPE_FAIL,
    payload: error,
});

export const deleteServiceType = serviceTypeId => ({
    type: DELETE_SERVICE_TYPE,
    payload: serviceTypeId,
});

export const deleteServiceTypeSuccess = serviceTypeId => ({
    type: DELETE_SERVICE_TYPE_SUCCESS,
    payload: serviceTypeId,
});

export const deleteServiceTypeFail = error => ({
    type: DELETE_SERVICE_TYPE_FAIL,
    payload: error,
});

export const bulkDeleteServiceType = serviceTypeIds => ({
    type: BULK_DELETE_SERVICE_TYPE,
    payload: serviceTypeIds,
});

export const bulkDeleteServiceTypeSuccess = serviceTypeIds => ({
    type: BULK_DELETE_SERVICE_TYPE_SUCCESS,
    payload: serviceTypeIds,
});

export const bulkDeleteServiceTypeFail = error => ({
    type: BULK_DELETE_SERVICE_TYPE_FAIL,
    payload: error,
});

export const exportServiceType = data => ({
    type: EXPORT_SERVICE_TYPE,
    payload: data
});

export const exportServiceTypeSuccess = data => ({
    type: EXPORT_SERVICE_TYPE_SUCCESS,
    payload: data,
});

export const exportServiceTypeFail = error => ({
    type: EXPORT_SERVICE_TYPE_FAIL,
    payload: error,
});

//reset
export const resetServiceTypeState = () => {
    return {
        type: RESET_SERVICE_TYPE_STATE,
    }
}

//reset attachment
export const resetServiceTypeAttachmentState = () => {
    return {
        type: RESET_SERVICE_TYPE_ATTACHMENT_STATE,
    }
}

